import constants from "../../commonUtils/constants";
import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  filters: { keyword: "" },
  ExtDataCategoriesList: constants.extraction.listInitialState,
  extDataCategory: null,
  openModal: false,
  errors: {},
  errorMessage: ""
};

const ExtDataCategories = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
      
    case actionTypes.SET_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
      
    case actionTypes.SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    
    case actionTypes.SET_OPEN_MODAL:
      return {
        ...state,
        openModal: action.payload,
        loading: action.payload ? state.loading : false,
        extDataCategory: action.payload ? state.extDataCategory : null,
      };
    
    case actionTypes.SET_EXT_DATA_CATEGORY:
      return {
        ...state,
        extDataCategory: action.payload,
      };
      
    case actionTypes.GET_EXT_DATA_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        ExtDataCategoriesList: action.payload,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.GET_EXT_DATA_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to fetch data categories"
      };

    case actionTypes.GET_EXT_DATA_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        extDataCategory: action.payload,
        openModal: true,
        errors: {},
        errorMessage: "",
      };
    
    case actionTypes.GET_EXT_DATA_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        openModal: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to fetch data categories"
      };
      
    case actionTypes.CREATE_EXT_DATA_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        openModal: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.CREATE_EXT_DATA_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors || {},
        errorMessage: action.payload.message || "Failed to create data category"
      };
      
    case actionTypes.UPDATE_EXT_DATA_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        openModal: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.UPDATE_EXT_DATA_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors || {},
        errorMessage: action.payload.message || "Failed to update data category"
      };
    
    case actionTypes.UPDATE_EXT_DATA_CATEGORIES_ORDER_SUCCESS:
      return {
        ...state,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.UPDATE_EXT_DATA_CATEGORIES_ORDER_FAILURE:
      return {
        ...state,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to update order"
      };
    
    case actionTypes.DELETE_EXT_DATA_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: {},
        errorMessage: "",
      };
      
    case actionTypes.DELETE_EXT_DATA_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data || {},
        errorMessage: action.payload.message || "Failed to delete data category"
      };
      
    default:
      return state;
  }
};

export default ExtDataCategories;